import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { DateTime } from "luxon";
import ShareButton from "./ShareButton";
import { ChevronDown, ChevronRight } from "lucide-react";
import ProspectCard from "./ProspectCard";
import LogsCard from "./LogsCard";
import axios from "@/lib/axios";
import { useEffect, useState } from "react";
import { toast } from "@/hooks/use-toast.js";
import { Separator } from "@/components/ui/separator";

const SecretShopperLogs = ({ secretShopper, community, initiateCallback, title }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [logs, setLogs] = useState([]);
    const [metrics, setMetrics] = useState({});

    const handleCallBack = () => {
        if (!secretShopper.is_active) {
            return;
        }

        initiateCallback();
    }

    useEffect(() => {
        if (!secretShopper?.id) {
            return;
        }

        if (!isOpen) {
            return;
        }

        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/secret-shopper/${secretShopper?.id}/logs`);
                setLogs(response.data.logs || []);
                setMetrics(response.data.metrics)
            } catch (error) {
                toast({ title: "Error fetching data", variant: "destructive" });
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [secretShopper, isOpen]);

    const isActive = !!secretShopper.is_active;

    const headerTitle = title ?? (
        isActive
            ? DateTime.fromISO(secretShopper.created_at).toFormat('MMM dd, yyyy')
            : `${DateTime.fromISO(secretShopper.created_at).toFormat('MMM dd, yyyy')} - ${DateTime.fromISO(secretShopper.updated_at).toFormat('MMM dd, yyyy')}`
    );

    return (
        <Collapsible className="border rounded-lg space-y-2" open={isOpen} onOpenChange={setIsOpen}>
            <CollapsibleTrigger className="flex flex-row justify-between p-4 cursor-pointer w-full" >
                <div className="flex flex-row gap-3">
                    {isOpen && <ChevronDown className="h-6 w-6 self-center" />}
                    {!isOpen && <ChevronRight className="h-6 w-6 self-center" />}
                    <span className="text-xl font-semibold">
                        {headerTitle}
                    </span>
                </div>
                <div className="grid grid-cols-2 items-center">
                    <ShareButton secretShopper={secretShopper} />
                    <div className="flex flex-row justify-end items-center gap-2">
                        <span
                            className={`self-end px-2 py-1 text-xs font-medium rounded-full ${isActive ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"
                                }`}
                        >
                            {isActive ? 'Active' : 'Closed'}
                        </span>
                    </div>
                </div>
            </CollapsibleTrigger>
            <CollapsibleContent className="grid grid-cols-1 gap-5">
                <Separator />
                <div className="p-4 grid gap-5">
                    <ProspectCard
                        isLoading={isLoading}
                        logs={logs}
                        secretShopperData={secretShopper}
                        community={community}
                        metrics={metrics}
                        initiateCallback={handleCallBack}
                    />
                    <LogsCard
                        logs={logs}
                        community={community}
                        secretShopper={secretShopper}
                        isLoading={isLoading}
                    />
                </div>
            </CollapsibleContent>
        </Collapsible>
    )
}

export default SecretShopperLogs;